/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Ported from @material-ui/core@4.11.3
 */

import React from 'react';
import cx from 'classnames';
import styles from './TabIndicator.module.scss';
type Props = {
  className?: string;
  classes?: {
    [key: string]: string;
  };
  style?: {
    [key: string]: number | string;
  };
};
/**
 * @ignore - internal component.
 */

function TabIndicator(props: Props) {
  const { className, classes = {}, ...other } = props;
  return <span className={cx(styles.root, classes.indicator, className)} {...other} />;
}

export default TabIndicator;
